/* eslint-disable */
// Chakra Imports
import { Box, HStack, Flex, Text, useColorModeValue, Icon } from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { IoArrowBackCircleSharp   } from "react-icons/io5"
import AdminNavbarLinks from 'components/navbar/NavbarLinksAdmin';
import { useNavigate } from 'react-router-dom';

export default function AdminNavbar(props: {
	secondary: boolean;
	message: string|boolean;
	brandText: string;
	logoText: string;
	fixed: boolean;
	renderSidebar: boolean;
	backButtonTo?: string;
	onOpen: (...args: any[]) => any;
}) {
	const [ scrolled, setScrolled ] = useState(false);

	useEffect(() => {
		window.addEventListener('scroll', changeNavbar);

		return () => {
			window.removeEventListener('scroll', changeNavbar);
		};
	});

	const { secondary,  brandText, renderSidebar, backButtonTo } = props;
	const navigate = useNavigate()

	// Here are all the props that may change depending on navbar's type or state.(secondary, variant, scrolled)
	let mainText = useColorModeValue('navy.700', 'white');
	let navbarPosition = 'fixed' as const;
	let navbarFilter = 'none';
	let navbarBackdrop = 'blur(20px)';
	let navbarShadow = 'none';
	let navbarBg = useColorModeValue('rgba(244, 247, 254, 0.2)', 'rgba(11,20,55,0.5)');
	let navbarBorder = 'transparent';
	let secondaryMargin = '-18px';
	let paddingX = '15px';
	let gap = '0px';
	const changeNavbar = () => {
		if (window.scrollY > 1) {
			setScrolled(true);
		} else {
			setScrolled(false);
		}
	};

	return (
		<Box
			position={navbarPosition}
			zIndex={999}
			boxShadow={navbarShadow}
			bg={navbarBg}
			borderColor={navbarBorder}
			filter={navbarFilter}
			backdropFilter={navbarBackdrop}
			backgroundPosition='center'
			backgroundSize='cover'
			borderRadius='16px'
			borderWidth='1.5px'
			borderStyle='solid'
			transitionDelay='0s, 0s, 0s, 0s'
			transitionDuration=' 0.25s, 0.25s, 0.25s, 0s'
			transition-property='box-shadow, background-color, filter, border'
			transitionTimingFunction='linear, linear, linear, linear'
			alignItems={{ xl: 'center' }}
			display={secondary ? 'block' : 'flex'}
			minH='75px'
			justifyContent={{ xl: 'center' }}
			lineHeight='25.6px'
			mx='auto'
			mt={{base: "-17px", lg: secondaryMargin}}
			pb='8px'
			right={{ base: '12px', md: '30px', lg: '30px', xl: '30px' }}
			px={{
				sm: paddingX,
				md: '10px'
			}}
			ps={{
				xl: '12px'
			}}
			pt='20px'
			top={{ base: '12px', md: '16px', xl: '18px' }}
			w={{
				base: 'calc(100vw - 5%)',
				md: 'calc(100vw - 8%)',
				lg: 'calc(100vw - 6%)',
				xl: renderSidebar?'calc(100vw - 280px)':'calc(100vw - 60px)',
				'2xl': renderSidebar?'calc(100vw - 290px)':'calc(100vw - 70px)',
			}}>
			<Flex
				w='100%'
				flexDirection={{
					sm: 'column',
					md: 'row'
				}}
				alignItems={{ xl: 'center' }}
				mb={gap}>
				<Box mb={{ sm: '8px', md: '0px' }} alignContent='center' display={'flex'}>
					<HStack alignSelf='center'>
						{backButtonTo?
							<Icon as={ IoArrowBackCircleSharp } w='30px' h="30px" _hover={{ color: 'whiteAlpha.800', transform: 'scale(1.1)', transition: 'transform 0.1s' }} onClick={() => navigate(backButtonTo)}/>
						:null}
						<Text
							color={mainText}
							bg='inherit'
							borderRadius='inherit'
							fontWeight='bold'
							fontSize={{base: '22px', lg: '28px'}}
							_hover={{ color: { mainText } }}
							_active={{
								bg: 'inherit',
								transform: 'none',
								borderColor: 'transparent'
							}}
							_focus={{
								boxShadow: 'none'
							}}>
							{brandText}
						</Text>
					</HStack>
				</Box>
				<Box ms='auto' w={{ sm: '100%', md: 'unset' }}>
					<AdminNavbarLinks
						onOpen={props.onOpen} 
						secondary={props.secondary}
						fixed={props.fixed}
					/>
				</Box>
			</Flex> 
		</Box>
	);
}
